/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ArrivalTimePostProcessing
 */
export interface ArrivalTimePostProcessing {
  /**
   *
   */
  readonly basicPostProcessing?: number;
}

/**
 * Check if a given object implements the ArrivalTimePostProcessing interface.
 */
export function instanceOfArrivalTimePostProcessing(
  value: object
): value is ArrivalTimePostProcessing {
  return true;
}

export function ArrivalTimePostProcessingFromJSON(json: any): ArrivalTimePostProcessing {
  return ArrivalTimePostProcessingFromJSONTyped(json, false);
}

export function ArrivalTimePostProcessingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ArrivalTimePostProcessing {
  if (json == null) {
    return json;
  }
  return {
    basicPostProcessing:
      json["basic_post_processing"] == null ? undefined : json["basic_post_processing"],
  };
}

export function ArrivalTimePostProcessingToJSON(json: any): ArrivalTimePostProcessing {
  return ArrivalTimePostProcessingToJSONTyped(json, false);
}

export function ArrivalTimePostProcessingToJSONTyped(
  value?: Omit<ArrivalTimePostProcessing, "basicPostProcessing"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {};
}
